"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var ButtonWithModal_1 = __importDefault(require("atomicComponents/organisms/Button/ButtonWithModal"));
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var single_1 = require("utils/selectors/single");
var MfaModal_1 = __importDefault(require("./MfaModal"));
var tableConf_1 = __importDefault(require("./tableConf"));
var Header = (0, HeaderMaker_1.default)(tableConf_1.default);
var Row = (0, RowMaker_1.default)(tableConf_1.default);
var Mfa = function () {
    var _a;
    var _b = __read(react_1.default.useState(false), 2), showMfaModal = _b[0], setShowMfaModal = _b[1];
    var userHas2fa = (0, react_redux_1.useSelector)(single_1.selectUserHas2fa);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var authenticators = userHas2fa
        ? [{ method: 'Authenticator app', status: 'Default', id: 'test-1', addedOn: (_a = profile === null || profile === void 0 ? void 0 : profile.mfaAddedOn) === null || _a === void 0 ? void 0 : _a.totp }]
        : [];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: " Multi-factor authentication" })), !showMfaModal
                        ? ((0, jsx_runtime_1.jsx)(ButtonWithModal_1.default, __assign({ size: "small", renderOnlyOnOpen: true, modalComponent: MfaModal_1.default, modalProps: { buttonAction: function () { return setShowMfaModal(!showMfaModal); } }, disabled: userHas2fa }, { children: "Add authentication method" })))
                        : (0, jsx_runtime_1.jsx)(MfaModal_1.default, { onClose: function () { return setShowMfaModal(false); } })] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", mt: 2 }, { children: "Enhance the security of your account by enabling multiple authentication methods. This is required for all users connecting to Xero or QuickBooks accounts." })), !!authenticators.length && ((0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1000 }, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: authenticators.map(function (auth) { return (0, jsx_runtime_1.jsx)(Row, { item: auth }, auth.id); }) })] })))] }));
};
exports.default = (0, SortHoC_1.default)(Mfa, { key: 'method', order: 1 });
